import { defineStore } from 'pinia'
const axios = require('axios');

// Outside of state to prevent resetting
let connectionsInitialized = null;

export const useConnections = defineStore('connections', {
    state() {
        return {
            facebookAccount: null,
            facebookPages: [],
            facebookGroups: [],
            instagramPages: [],
            //twitterAccount: null, //Currently part of other networks
            pinterestAccount: null,
            tableAccount: null,
            otherNetworks: [],
            deviceCount: null,
            showGroupMissingAppModal: false,
            lastConnectingGroup: null
        }
    },

    getters: {
        hasGroupsPostingViaAccount() {
            let result = false;
            this.facebookGroups.forEach((group) => {
                if(group.via_id === this.facebookAccount.id) {
                    result = true;
                }
            });
            return result;
        },

        hasFacebookPageScope() {
            return this.facebookAccount?.details.scopes.facebook_pages || false;
        },

        hasFacebookGroupScope() {
            return this.facebookAccount?.details.scopes.facebook_groups || false;
        },

        hasInstagramPageScope() {
            return this.facebookAccount?.details.scopes.instagram_pages || false;
        },

        hasMetaConnections() {
            return Boolean(this.facebookPages.length)
                || Boolean(this.facebookGroups.length)
                || Boolean(this.instagramPages.length);
        },

        hasInvalidFacebookAccountToken() {
            let result = false;
            if(
                this.facebookAccount
                && ! this.facebookAccount.has_token
            ) {
                result = true;
            }
            return result;
        },

        hasInvalidFacebookPageTokens() {
            let result = false;
            if(this.facebookPages) {
                this.facebookPages.forEach((page) => {
                    if(! page.has_token) {
                        result = true;
                    }
                })
            }
            return result;
        },

        /*hasInvalidTwitterAccountToken() {
            let result = false;
            if(
                this.twitterAccount
                && ! this.twitterAccount.has_token
            ) {
                result = true;
            }
            return result;
        },*/

        hasInvalidPinterestAccountToken() {
            let result = false;
            if(
                this.pinterestAccount
                && ! this.pinterestAccount.has_token
            ) {
                result = true;
            }
            return result;
        },

        hasInvalidFacebookTokens() {
            return this.hasInvalidFacebookAccountToken
                || this.hasInvalidFacebookPageTokens;
        },

        hasTableAccountConnection() {
            if (this.tableAccount) {
                return true;
            }

            return false;
        },

        publishableConnections() {
            let result = [];
            if(this.facebookPages.length) {
                result = result.concat(this.facebookPages);
            }
            if(this.facebookGroups.length) {
                result = result.concat(this.facebookGroups);
            }
            if(this.instagramPages.length) {
                result = result.concat(this.instagramPages);
            }
            /*if(this.twitterAccount) {
                result.push(this.twitterAccount);
            }*/
            if(this.pinterestAccount) {
                result.push(this.pinterestAccount);
            }
            if(this.tableAccount) {
                result.push(this.tableAccount);
            }
            if(this.otherNetworks.length) {
                result = result.concat(this.otherNetworks);
            }
            return result;
        }
    },

    actions: {
        ensureInitialized() {
            if(connectionsInitialized === null) {
                connectionsInitialized = this.refresh();
            }

            return connectionsInitialized;
        },

        refresh() {
            this.$reset(); // This should remain the only location
            return axios.get('/api/connections')
                .then((response) => {
                    this.deviceCount = response.data.meta.device_count;

                    let connections = response.data.data;
                    connections.forEach(connection => {
                        if(connection.type === 'facebook_account') {
                            this.facebookAccount = connection;
                        } else if(connection.type === 'facebook_page') {
                            this.facebookPages.push(connection);
                        } else if(connection.type === 'facebook_group') {
                            this.facebookGroups.push(connection);
                        } else if(connection.type === 'instagram_page') {
                            this.instagramPages.push(connection);
                        }/* else if(connection.type === 'twitter_account') {
                            this.twitterAccount = connection;
                        }*/ else if(connection.type === 'pinterest_account') {
                            this.pinterestAccount = connection;
                        } else if(connection.type === 'table_account') {
                            this.tableAccount = connection;
                        } else { //Assuming whatever is left is "other network"
                            this.otherNetworks.push(connection);
                        }
                    });
                });
        },

        refreshTableParties() {
            return axios.get('/api/connections?type=table_account&force=1')
                .then((response) => {
                    this.tableAccount = response.data.data.pop();
                });
        },

        disconnectConnection(id, type, force = false) {
            return axios.delete('/api/connections/' + id, {params: {force: force}})
                .then(() => {
                    this.removeConnection(id, type);
                });
        },

        removeConnection(id, type) {
            let index;
            switch (type) {
                case 'facebook_account':
                    this.facebookAccount = null;
                    break;
                case 'facebook_page':
                    index = this.facebookPages.findIndex((page) => page['id'] === id);
                    this.facebookPages.splice(index, 1)[0];
                    break;
                case 'facebook_group':
                    index = this.facebookGroups.findIndex((group) => group['id'] === id);
                    this.facebookGroups.splice(index, 1)[0];
                    break;
                case 'instagram_page':
                    index = this.instagramPages.findIndex((page) => page['id'] === id);
                    this.instagramPages.splice(index, 1)[0];
                    break;
                // case 'twitter_account':
                //     this.twitterAccount = null;
                //     break;
                case 'pinterest_account':
                    this.pinterestAccount = null;
                    break;
                case 'table_account':
                    this.tableAccount = null;
                    break;
                default:
                    break;
            }
       },

        getFacebookGroup(id) {
            return _.find(this.facebookGroups, {id: id});
        },

        getConnectionById(id) {
            return this.publishableConnections.find((connection) => {
                return connection.id == id;
            })
        },

        toggleGroupMissingAppModal() {
            this.$patch({showGroupMissingAppModal: ! this.showGroupMissingAppModal});
        }
    }
});
